// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3MWTl","content":"GlobalSearch_content__2KO2I"};